import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgxExtendedPdfViewerModule,
  PdfLoadingStartsEvent,
} from 'ngx-extended-pdf-viewer';
import { eventIdentifierMapper } from 'src/app/@helpers/event-identifier-mapper';
import { ReportsEventRouteSlugService } from 'src/app/@services/reports-event-route-slug.service';
import { ExternalRegistrationStateService } from 'src/app/@stores/external-registration-state.service';
import { eventScopedCommandsWithRegistration } from 'src/app/@utils/reports-navigation';
import { SynSocialShareComponent } from '../syn-social-share';
import { SynSplashScreenService } from '../syn-splash-screen';

@Component({
  selector: 'syn-pdf-viewer',
  templateUrl: './syn-pdf-viewer.component.html',
  styleUrls: ['./syn-pdf-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatButtonModule,
    NgxExtendedPdfViewerModule,
    SynSocialShareComponent,
  ],
})
export class SynPdfViewerComponent implements OnInit {
  private readonly _splashScreenService = inject(SynSplashScreenService);
  private readonly _location = inject(Location);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _reportsEventSlug = inject(ReportsEventRouteSlugService);
  private readonly _externalRegistrationState = inject(
    ExternalRegistrationStateService
  );

  public pdfSrc = input.required<string>();
  public title = input.required<string>();

  ngOnInit(): void {
    this._splashScreenService.show();
  }

  protected get pdfName(): string {
    const slug = this._reportsEventSlug.effectiveSlugWithPersistence(
      this._route
    );
    return `${eventIdentifierMapper(slug)} - ${this.title()}`;
  }

  protected get showShareButton(): boolean {
    return true;
  }

  protected navigateToReports(): void {
    const from = this._route.snapshot.queryParams['from'];
    const section = this._route.snapshot.queryParams['section'];
    const eventName = this._reportsEventSlug.effectiveSlugWithPersistence(
      this._route
    );

    if (from === 'home' && eventName) {
      const registrationId =
        this._route.snapshot.paramMap.get('registrationId') ||
        this._externalRegistrationState.$registrationId() ||
        null;
      this._router.navigate(
        eventScopedCommandsWithRegistration(
          this._router,
          eventName,
          registrationId
        ),
        {
          fragment: section || undefined,
          replaceUrl: true,
        }
      );
    } else {
      this._location.back();
    }
  }

  protected pdfLoadingStarts(_event: PdfLoadingStartsEvent): void {
    this._splashScreenService.hide();
  }
}
